import { css } from '@emotion/react';

import { theme } from 'global';

export const appbar = css`
  background-color: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.neutral[200]};
  height: var(--header-height);
`;

export const toolbar = css`
  padding: 14px 24px !important;
  min-height: var(--header-height) !important;

  @media screen and (max-width: ${theme.breaks.md}px) {
    padding: 1rem 20px !important;
  }
`;

export const logo = css`
  user-select: none;
`;

export const helpButton = css`
  width: 94px;
  height: 38p;
  border-radius: 30px;
  padding: 4px 12px;
  margin-left: 12px;
  color: ${theme.colors.neutral[600]};
  background-color: ${theme.colors.neutral[0]};

  & > div {
    display: flex;
    column-gap: 6px;

    & > svg {
      background-color: #dcf995;
      padding: 4px;
      border-radius: 30px;
      &:hover {
        color: ${theme.colors.secondary};
      }
    }

    & > span {
      align-content: center;
      font-weight: 500;
    }
  }

  &:hover {
    color: ${theme.colors.secondary};
  }

  @media screen and (max-width: ${theme.breaks.md}px) {
    order: 1;
    margin-left: 12px;
  }
`;
